import Vue from 'vue'
import './common/md5'
import './common/COVERAPP'
import App from './App.vue'
import router from './router'
import store from './store'
import request from './common/request'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

import Vconsole from 'vconsole';
//new Vconsole();